import React, { useEffect, useState } from 'react';
import { FiCheckSquare, FiFilter, FiSquare } from 'react-icons/fi';

function TouroperatorFilter({ data, onChoose, children }) {
  const [isOpened, setOpened] = useState(false);
  const [filteredTouroperator, setFilteredTouroperator] = useState([]);
  const [operators, setOperators] = useState([]);

  useEffect(() => {
    if (data.status.operators) {
      const { operators } = data.status;
      const sortedOperators = operators.sort((a, b) => a.minprice - b.minprice);
      setOperators(sortedOperators);
    }
  }, [data]);

  function openTouroperatorsFilter() {
    setOpened(!isOpened);
  }

  function chooseOption(id) {
    if (filteredTouroperator.includes(id)) {
      const newArr = filteredTouroperator.filter((item) => item !== id);
      setFilteredTouroperator(newArr);
      onChoose(newArr);
    } else {
      setFilteredTouroperator([...filteredTouroperator, id]);
      onChoose([...filteredTouroperator, id]);
    }
  }

  function resetFitler() {
    setFilteredTouroperator([]);
    onChoose([]);
  }

  return (
    <div className="search__filter">
      {children}
      <div className="search__filter-title" onClick={openTouroperatorsFilter}>
        <FiFilter />
        Туроператоры
      </div>
      {isOpened ? (
        <div className="search__filter-container">
          <div className="filter__group">
            <div className="filter__group-title" onClick={resetFitler}>
              {filteredTouroperator.length === 0 ? (
                <FiCheckSquare className="filter__title-square_chosen" />
              ) : (
                <FiSquare />
              )}
              Все туроператоры
            </div>
            <div className="filter__list">
              {operators.map((operator) => {
                const { minprice, status, name, code } = operator;
                if (minprice > 0 || status === 'searching') {
                  return (
                    <div className="filter__item" key={code}>
                      <div
                        className="filter__item-title"
                        onClick={() => chooseOption(code)}
                      >
                        {filteredTouroperator.includes(code) ? (
                          <FiCheckSquare className="filter__title-square_chosen" />
                        ) : (
                          <FiSquare />
                        )}
                        {name}
                      </div>
                      {status === 'searching' ? (
                        <div className="loading-rotator"></div>
                      ) : (
                        <div
                          className="filter__item-data"
                          onClick={() => chooseOption(code)}
                        >
                          {minprice}
                        </div>
                      )}
                    </div>
                  );
                } else return null;
              })}
            </div>
          </div>
          <div className="filter__group">
            <div className="filter__group-title">Туров нет</div>
            <div className="filter__list">
              {operators.map((operator) => {
                const { status, name, code } = operator;
                if (status === 'noresult') {
                  return (
                    <div className="filter__item" key={code}>
                      <div className="filter__item-title filter__item-title_disabled">
                        {name}
                      </div>
                    </div>
                  );
                } else return null;
              })}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default TouroperatorFilter;
